import { render, staticRenderFns } from "./questionRateTable.vue?vue&type=template&id=6f770de1"
import script from "./questionRateTable.vue?vue&type=script&lang=js"
export * from "./questionRateTable.vue?vue&type=script&lang=js"
import style0 from "./questionRateTable.vue?vue&type=style&index=0&id=6f770de1&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports